// src/redux/Filter/filter.reducer.js

export const FILTER_PERSISTED_PAGES = [
  "orders",
  "users",
  "manage-sub-admin",
  "mfd-management",
]; // add your pages here

const SAVE_FILTER = "filter/SAVE";
const CLEAR_FILTER = "filter/CLEAR";
const CLEAR_ALL_FILTERS = "filter/CLEAR_ALL";
const SAVE_LIST_STATE = "filter/SAVE_LIST_STATE";
const CLEAR_LIST_STATE = "filter/CLEAR_LIST_STATE";

// Key under which list state (tab / page / page size) is kept, per page
export const LIST_STATE_KEY = "_listState";

// ─── Action Creators ───────────────────────────────────────────────
export const saveFilter = (pageKey, selections) => ({
  type: SAVE_FILTER,
  payload: { pageKey, selections },
});

export const clearFilter = (pageKey) => ({
  type: CLEAR_FILTER,
  payload: pageKey,
});

export const clearAllFilters = () => ({
  type: CLEAR_ALL_FILTERS,
});

// Merges partial list state, e.g. saveListState("orders", { page: 2 })
export const saveListState = (pageKey, listState) => ({
  type: SAVE_LIST_STATE,
  payload: { pageKey, listState },
});

export const clearListState = (pageKey) => ({
  type: CLEAR_LIST_STATE,
  payload: pageKey,
});

// ─── Reducer ───────────────────────────────────────────────────────
const initialState = {};

export default function filterReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_FILTER: {
      const { pageKey, selections } = action.payload;
      if (!FILTER_PERSISTED_PAGES.includes(pageKey)) return state; // guard: ignore non-whitelisted pages
      return { ...state, [pageKey]: selections };
    }
    case CLEAR_FILTER: {
      const next = { ...state };
      delete next[action.payload];
      return next;
    }
    case CLEAR_ALL_FILTERS:
      return {};
    case SAVE_LIST_STATE: {
      const { pageKey, listState } = action.payload;
      if (!FILTER_PERSISTED_PAGES.includes(pageKey)) return state;
      const all = state[LIST_STATE_KEY] || {};
      return {
        ...state,
        [LIST_STATE_KEY]: {
          ...all,
          [pageKey]: { ...all[pageKey], ...listState },
        },
      };
    }
    case CLEAR_LIST_STATE: {
      const all = { ...(state[LIST_STATE_KEY] || {}) };
      delete all[action.payload];
      return { ...state, [LIST_STATE_KEY]: all };
    }
    default:
      return state;
  }
}